import { useContext } from 'react';
import { InvoicesContextObject, InvoicesContextType } from '../context/InvoicesContextObject';

export function useInvoices(): InvoicesContextType {
  const context = useContext(InvoicesContextObject);
  
  if (context === undefined) {
    throw new Error('useInvoices must be used within an InvoicesContext');
  }
  
  return context;
}